var generic = generic || {};
var site = site || {};
var Drupal = Drupal || {};
var settings = Drupal.settings || {};
var globalVars = settings.global_variables || {};
site.userInfoCookie = site.userInfoCookie || {};
site.userInfoCookie.getValue =
  site.userInfoCookie.getValue ||
  function () {
    return '';
  };
Drupal.behaviors.siteHeaderFormatterV2 = (function ($) {
  var $html = $();
  var $body = $();
  var $template = $();
  var $bottomLinksWrapper = $();
  var $bottomLinks = $();
  var $gnavOffers = $();
  var $gnavSearchIcon = $();
  var $gnavSearchLabel = $();
  var $gnavMobSearchClose = $();
  var $gnavSearchSection = $();
  var $gnavPCSearchWrapper = $();
  var $gnavPCSearch = $();
  var $gnavPCSearchSection = $();
  var $gnavPCSearchContent = $();
  var $gnavPCSearchResults = $();
  var $gnavMobMainLinks = $();
  var $mobMenuLinksLabel = $();
  var $gnavHamburger = $();
  var $gnavHamburgerInput = $();
  var $gnavMainSectionWrapper = $();
  var $gnavMobileSectionsMenu = $();
  var $gnavMainSection = $();
  var $gnavMainSectionContent = $();
  var $gnavMainSectionTrigger = $();
  var $gnavMainSectionTriggerLink = $();
  var $mainSectionTriggerReset = $();
  var $triggerResetLabel = $();
  var $subSectionTriggerReset = $();
  var $linksTriggerReset = $();
  var $allSectionGroups = $();
  var $allSectionTriggerResetLabels = $();
  var $allSectionGroupContent = $();
  var $allSectionGroupsTrigger = $();
  var $allSectionGroupsMobTrigger = $();
  var $gnavSectionGroup = $();
  var $allGnavLinks = $();
  var $gnavLinkTout = $();
  var $gnavLinkToutContent = $();
  var $staticLinks = $();
  var $accountSignedIn = $();
  var $accountContent = $();
  var $accountGreetingText = $();
  var $accountUserName = $();
  var $emailSignupLinks = $();
  var emailAnchoredLink = false;
  // Calculate desktop for mobile menu stuff.
  var bps = Unison.fetch.all();
  var bp = Unison.fetch.now();
  var isMediaLandscape = window.matchMedia('(orientation: landscape)').matches ? true : false;
  var isDesktop = parseInt(bp.width, 10) >= parseInt(bps.landscape, 10);
  var position = $(window).scrollTop();
  var offersHeight = 0;
  var hideHeaderOnScroll = false;
  var linksToNavigate =
    'a, button, input, select, textarea, iframe, object, embed, *[tabindex], *[contenteditable]';
  var tabbableElements =
    'a:tabbable, button:tabbable, input:tabbable, select:tabbable, textarea:tabbable, iframe:tabbable, object:tabbable, embed:tabbable, *[tabindex]:tabbable';
  var noTabbableElements = '[tabindex=-1], [disabled], [aria-hidden=true], [aria-expanded=false]';
  var timer;
  var behavior = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      $html = $('html');
      $body = $('body');
      $template = $('.js-site-header-formatter-v2', context);
      $gnavSearchIcon = $('.js-site-header-formatter__search-icon', $template);
      $gnavSearchLabel = $('.js-site-header-formatter__search-mob', $template);
      $gnavSearchSection = $('.js-site-header-formatter__search-label-mob', $gnavSearchLabel);
      $gnavMobSearchClose = $('.js-site-header-formatter__search-toggle', $gnavSearchLabel);
      $gnavPCSearchWrapper = $('.js-site-header-formatter__search', $template);
      $gnavPCSearch = $('.js-site-header-formatter__search-label', $template);
      $gnavPCSearchSection = $('.js-site-header-formatter__search-content', $gnavPCSearchWrapper);
      $gnavPCSearchContent = $('.js-header-search', $gnavPCSearchSection);
      $gnavPCSearchResults = $('.js-search-result', $gnavPCSearchSection);
      $gnavMobMainLinks = $('.js-site-header-formatter__sections-main-links', $template);
      $mobMenuLinksLabel = $('.js-site-header-formatter__menu-links-label', $template);
      $bottomLinksWrapper = $('.js-site-header-formatter-links-container', context);
      $bottomLinks = $('a', $bottomLinksWrapper);
      $emailSignupLinks = $('.js-header-email-signup-link', $template);

      $gnavOffers = $('.site-header-formatter__offers', $template);
      $gnavHamburger = $('.js-gnav-mobile-trigger', $template);
      $gnavHamburgerInput = $('.js-site-header-formatter__trigger-input', $template);
      $gnavMainSectionWrapper = $('.js-site-header-formatter__sections', $template);
      $gnavMobileSectionsMenu = $(
        '.js-site-header-formatter__mobile-menu-header',
        $gnavMainSectionWrapper
      );
      $gnavMainSection = $('.js-header-nav-section__section-v2', $gnavMainSectionWrapper);
      $gnavMainSectionContent = $('.js-header-nav-section__section-content', $gnavMainSection);
      $gnavMainSectionTriggerLink = $('.js-header-nav-section__section-main-link', $gnavMainSection);
      $gnavMainSectionTrigger = $('.js-header-nav-section__section-label', $gnavMainSection);
      $mainSectionTriggerReset = $('.js-site-header-formatter__trigger-reset', $template);
      $triggerResetLabel = $('.js-gnav-section-trigger-reset', $template);
      $subSectionTriggerReset = $('.js-site-header-formatter-subsection-trigger-reset', $template);
      $linksTriggerReset = $('.js-site-header-formatter-links-trigger-reset', $template);
      // These elements are in gnav_section_formatter_v1, we collapse them too when gnav is closed.
      $allSectionGroups = $('.js-gnav-section-formatter-v1', $template);
      $allSectionTriggerResetLabels = $allSectionGroups.find(
        '.js-gnav-section-formatter__link--trigger'
      );
      $allSectionGroupContent = $('.js-gnav-section-formatter__content-wrapper', $allSectionGroups);
      $allSectionGroupsTrigger = $(
        '.js-gnav-section-formatter-trigger, .js-gnav-section-formatter-mob-trigger',
        $allSectionGroups
      );
      $allSectionGroupsMobTrigger = $('.js-gnav-section-formatter-mob-trigger', $allSectionGroups);
      $gnavSectionGroup = $('.js-gnav-section-group-v1', $template);
      $staticLinks = $('.js-gnav-section-group-static-link-trigger', $gnavMainSectionWrapper);
      $allGnavLinks = $('.js-gnav-section-formatter__content-wrapper', $template);
      $gnavLinkTout = $('.js-gnav-link-tout', $allGnavLinks);
      $gnavLinkToutContent = $('.js-gnav-link-tout-content', $allGnavLinks);
      hideHeaderOnScroll = $template.hasClass('hide-site-header-on-scroll');
      offersHeight = $gnavOffers.outerHeight(true);

      // Account Signed In
      $accountSignedIn = $('.js-site-header-formatter-signin', $template);
      $accountContent = $('.js-site-header-formatter-account', $template);
      $accountGreetingText = $('.js-site-header-formatter-link-greeting-text', $accountContent);
      $accountUserName = $('.js-account-username', $accountGreetingText);

      $body.addClass('gnav-site-header-formatter-v2');

      function widthSpecificClass() {
        if (isDesktop) {
          $body.addClass('horizontal-navbar').removeClass('mobile-navbar');
          $('.mobile-nav-links').children().unwrap();
          $gnavPCSearchResults.wrapAll('<div class="search-result-container"></div>');
        } else {
          $body.addClass('mobile-navbar').removeClass('horizontal-navbar');
          $('.search-result-container').children().unwrap();
          $('.header-nav-section__section-wrapper')
            .wrapAll('<div class="mobile-nav-links js-mobile-nav-links"></div>');
        }
      }

      widthSpecificClass();

      if ($.cookie('hide_header_offer_banner')) {
        $template.toggleClass('header-offers-banner-hidden', true);
      }
      $(document).on('user.loaded', function (e, val) {
        var $loyaltyJoin = $('.js-site-header-formatter-loyalty-join', $template);
        var $loyaltyJoined = $('.js-site-header-formatter-loyalty-joined', $template);
        var $loyaltyTextJoined = $('.js-gnav-loyalty-text', $loyaltyJoined);
        var $loyaltyPtsJoined = $('.js-gnav-loyalty-pts', $loyaltyJoined);
        var $loyaltyAccountLink = $('.js-account-links__loyalty', context);
        var pointsPrefixSpace = '';
        var loyaltyCopy = '';
        var userFirstName = site.userInfoCookie.getValue('first_name');
        var userLastName = site.userInfoCookie.getValue('last_name') || globalVars?.default_user_name || '';
        var firstname = userFirstName ? userFirstName + ',' : '';
        var isLoyaltyPricesEnabled =
          Drupal.settings &&
          Drupal.settings.common &&
          Drupal.settings.common.loyalty_prices_enabled;
        var showLoyaltyPoints = settings.show_points_for_loyalty ? 'points' : 'current_qualifying';
        var accountHeaderText = $accountGreetingText.data('account-header');

        if (val.signed_in) {
          if (
            globalVars?.show_user_last_name &&
            !_.isUndefined(userLastName) &&
            !_.isNull(userLastName) &&
            $accountGreetingText.length > 0
          ) {
            $accountUserName.html(userLastName + globalVars.honorifics);
            $accountSignedIn.addClass('hidden');
            $accountContent.removeClass('hidden');
          } else if (
            !_.isUndefined(userFirstName) &&
            !_.isNull(userFirstName) &&
            $accountGreetingText.length > 0
          ) {
            $accountUserName.html(userFirstName);
            $accountSignedIn.addClass('hidden');
            $accountContent.removeClass('hidden');
          } else if (accountHeaderText) {
            $accountGreetingText.html(accountHeaderText);
            $accountSignedIn.addClass('hidden');
            $accountContent.removeClass('hidden');
          }
        }

        if (!val.is_pro) {
          $loyaltyJoin.removeClass('hidden');
          if (val.signed_in) {
            if (isLoyaltyPricesEnabled) {
              $loyaltyJoin.addClass('hidden');
              $loyaltyJoined.removeClass('hidden');
              loyaltyCopy = firstname + pointsPrefixSpace + $loyaltyTextJoined.first().text();
              $loyaltyTextJoined.text(loyaltyCopy);
            } else if (val.is_loyalty_member) {
              $loyaltyAccountLink.removeClass('hidden');
              $loyaltyJoin.addClass('hidden');
              $loyaltyJoined.removeClass('hidden');
              loyaltyCopy = site.userInfoCookie.getValue(showLoyaltyPoints)
                ? site.userInfoCookie.getValue(showLoyaltyPoints)
                : '';
              loyaltyCopy = loyaltyCopy + pointsPrefixSpace + $loyaltyPtsJoined.first().text();
              $loyaltyPtsJoined.text(loyaltyCopy);
            }
          }
        }
      });

      function updateNavStatus() {
        var scrollPos = $(window).scrollTop();
        var headerHeight = $template.outerHeight(true);
        var headerBarHeight = headerHeight - offersHeight;
        var noSticky = $body.hasClass('site-header-formatter--large-logo')
          ? headerHeight
          : offersHeight;

        // If the user scroll down, hide the Nav.
        if (scrollPos <= position) {
          $body.toggleClass('site-header-formatter--hidden', false);
          $body.toggleClass('site-header-formatter--after-pos', false);
        } else if (scrollPos > headerHeight) {
          $body.toggleClass('site-header-formatter--hidden', true);
          $body.toggleClass('site-header-formatter--sticky', true);
          $body.addClass('sticky-header-opened');
          if (position > headerHeight + 10) {
            $body.toggleClass('site-header-formatter--after-pos', true);
          }
        }

        if (scrollPos <= noSticky) {
          $body.toggleClass('site-header-formatter--sticky', false);
          $body.removeClass('sticky-header-opened');
        }

        if (
          scrollPos <= headerBarHeight * 2 &&
          scrollPos >= headerHeight &&
          scrollPos <= position
        ) {
          $body.addClass('site-header-formatter--up');
        } else if (
          $body.hasClass('site-header-formatter--up') &&
          (position > headerBarHeight * 2 || scrollPos <= headerHeight)
        ) {
          $body.removeClass('site-header-formatter--up');
          if (
            scrollPos <= headerHeight &&
            $body.hasClass('site-header-formatter--large-logo') &&
            !$body.hasClass('site-header-formatter--hidden') &&
            !$body.hasClass('site-header-formatter--sticky')
          ) {
            $('body, html').animate({ scrollTop: 0 }, 500);
          }
        }

        position = scrollPos;
      }

      // Close the nav.
      function closeGnav(keepActive) {
        $html.toggleClass('active-gnav', keepActive).delay(1000);
        $gnavMainSectionWrapper.attr('aria-expanded', keepActive || isDesktop);
        $gnavMainSectionWrapper.toggleClass('content-panel-visible', keepActive).delay(1000);
        if (!isDesktop) {
          $gnavMainSectionWrapper.toggleClass('search-panel-visible', keepActive);
        }
        // Reset Header Nav Section elements state.
        $gnavMainSection.attr('aria-expanded', 'false');
        $gnavMainSectionContent.attr('aria-hidden', 'true');

        $(document).trigger('close_cart_confirm_overlay');

        // Reset Section Formatter elements state.
        $allSectionGroups.attr('aria-expanded', 'false');
        $allSectionGroupContent.attr('aria-hidden', 'true');
        $gnavSectionGroup.removeClass('active-section-group');
        $subSectionTriggerReset.prop('checked', true);
        $gnavMainSectionContent.removeClass('gnav-second-panel');
        $allSectionGroupsMobTrigger.prop('checked', false);

        // Reset Links elements state for the second panel.
        $linksTriggerReset.prop('checked', true);
        $allGnavLinks.attr('aria-expanded', 'false');
        $gnavLinkToutContent.attr('aria-hidden', 'true');

        if (!keepActive) {
          $mainSectionTriggerReset.prop('checked', true);

          if (!isDesktop) {
            $gnavHamburger.prop('checked', false);
          }
        }
      }

      function toggleMobileMenu() {
        // If mobile content is open then reset radio buttom for PC.
        $mainSectionTriggerReset.prop('checked', true);
        if ($gnavMainSectionWrapper.attr('aria-expanded') === 'false') {
          $html.toggleClass('active-gnav', true);
          $gnavMainSectionWrapper.attr('aria-expanded', 'true');
        } else {
          closeGnav();
        }
      }

      function toggleSectionGroup(item) {
        var $self = $(item);
        var $parent = $self.parents('.js-gnav-section-group-v1');
        var expand = $self.is(':checked');
        var $mainHeaderNav = $self.closest('.js-header-nav-section__section-content');
        var $siblingSectionGroupContent = $self.siblings(
          '.js-gnav-section-formatter__content-wrapper'
        );
        var $parentSectionGroup = $self.closest('.js-gnav-section-formatter-v1');

        if (!isDesktop && $self.hasClass('js-gnav-section-formatter-mob-trigger')) {
          $allSectionGroupsMobTrigger.not($self).prop('checked', false);
        }

        $linksTriggerReset.prop('checked', true);
        $allGnavLinks.attr('aria-expanded', 'false');
        $gnavLinkToutContent.attr('aria-hidden', 'true');
        $gnavLinkTout.removeClass('active-links-group');
        $allSectionGroupContent.attr('aria-expanded', 'false');
        $allSectionGroupContent.attr('aria-hidden', 'true');
        $allSectionGroups.attr('aria-expanded', 'false');
        $gnavSectionGroup.removeClass('active-section-group');

        // Open the respective Section Group Content
        $siblingSectionGroupContent.attr('aria-expanded', expand);
        $siblingSectionGroupContent.attr('aria-hidden', !expand);
        $parentSectionGroup.attr('aria-expanded', expand);
        $parent.addClass('active-section-group');
        $mainHeaderNav.addClass('gnav-second-panel');
      }

      function gnavPcTrigger($self, e) {
        var $parent = $self.parents('.js-header-nav-section__section-v2');
        var $input = $parent.prev();
        var $subinput = $parent.find($allSectionTriggerResetLabels);
        var $content = $parent.find('.js-header-nav-section__section-content');
        var $subNav = $content.find('.js-gnav-section-formatter-v1').first();
        var $subNavcontent = $subNav.find('.js-gnav-section-formatter__content-wrapper');
        var keepActive = $content.length ? true : false;

        if ($input.prop('checked') === true) {
          return;
        }
        closeGnav(keepActive);
        if ($content.length) {
          e.preventDefault();
          $input.prop('checked', true);
          $subinput.prev().prop('checked', true);
          toggleSectionGroup($subinput);
          $html.toggleClass('active-utility-overlay', false);
          $html.toggleClass('active-gnav', true);
          $parent.attr('aria-expanded', 'true');
          $content.attr('aria-hidden', 'false');
          $subNav.attr('aria-expanded', 'true');
          $subNavcontent.attr('aria-hidden', 'false');
          $subNavcontent.attr('aria-expanded', 'true');

          $allSectionGroups.attr('aria-expanded', 'false');
          $allSectionGroupContent.attr('aria-hidden', 'true');
          $gnavSectionGroup.removeClass('active-section-group');
          $allGnavLinks.attr('aria-expanded', 'false');
          $gnavLinkToutContent.attr('aria-hidden', 'true');
        }
      }

      $('.js-header-arrow-down-icon').on('click keydown', function (e) {
        const key = e.key || e.which;

        if (e.type === 'click' || key === 'Enter' || key === 13) {
          e.preventDefault();
          $(this).prev().trigger('mouseover');
        }
      });

      function gnavMobileTrigger($self, e) {
        var $parent = $self.parents('.js-header-nav-section__section-v2');
        var $input = $parent.prev();
        var $content = $parent.find('.js-header-nav-section__section-content');
        var $subNav = $parent.find('.js-gnav-section-formatter-v1');
        var $searchSection = $self.parents('.js-header-nav-section__section-search');
        var isOnSearchSection = $searchSection.length > 0 ? true : false;

        e.preventDefault();

        if ($parent.attr('aria-expanded') === 'true') {
          $input.prop('checked', false);
          $parent.attr('aria-expanded', 'false');
          $content.attr('aria-hidden', 'true');
          $subNav.attr('aria-expanded', 'false');
          $gnavMainSectionWrapper.attr('aria-expanded', 'false');

          return;
        }

        closeGnav(true);
        if (!$content.length) {
          return;
        }
        $input.prop('checked', true);
        $html.toggleClass('active-utility-overlay', false);
        $gnavMainSectionWrapper.attr('aria-expanded', 'true');
        $subNav.attr('aria-expanded', 'true');
        $parent.attr('aria-expanded', 'true');
        $content.attr('aria-hidden', 'false');
        $gnavMainSectionWrapper.toggleClass('search-panel-visible', isOnSearchSection);
        // Reset Section Formatter elements state.
        if (!isDesktop) {
          $allSectionGroups.attr('aria-expanded', 'false');
          $allSectionGroupContent.attr('aria-hidden', 'true');
          $gnavSectionGroup.removeClass('active-section-group');
          var scrollToPos = $parent.offset().top - 20;

          scrollToPos = Math.max(0, scrollToPos);
          var containerScrollTop = $gnavMobMainLinks.scrollTop();
          var containerHeight = $gnavMobMainLinks.height();
          var isElementInView = scrollToPos >= containerScrollTop &&
                                scrollToPos <= (containerScrollTop + containerHeight);

          if (!isElementInView) {
            $gnavMobMainLinks.stop().animate({
              scrollTop: scrollToPos
            }, 300);
          }
        }
        $allGnavLinks.attr('aria-expanded', 'false');
        $gnavLinkToutContent.attr('aria-hidden', 'true');
      }

      function gnavHeaderTrigger() {
        // Calculate desktop for mobile menu stuff.
        if (isDesktop) {
          $gnavMainSectionTrigger
            .off('mouseover.siteHeader click.siteHeader touchstart.siteHeader')
            .on('click.siteHeader touchstart.siteHeader mouseover.siteHeader', function (e) {
              var $self = $(this);
              var isActiveGnav = $('html.active-gnav').length === 1 ? true : false;

              // Hover trigger only on active gnav
              if (e.type === 'mouseover' && isActiveGnav) {
                gnavPcTrigger($self, e);
              } else if (e.type === 'mouseover' || e.type === 'touchstart') {
                gnavPcTrigger($self, e);
              }
            });
          $gnavMainSection.on('mouseout', function (e) {
            if (
              !$gnavMainSection.is(e.relatedTarget) &&
              !$gnavMainSection.has(e.relatedTarget).length
            ) {
              closeGnav();
            }
          });
        } else {
          $gnavMainSectionTriggerLink
            .off('mouseover.siteHeader click.siteHeader touchstart.siteHeader')
            .on('click.siteHeader', function (e) {
              var $self = $(this);

              gnavMobileTrigger($self, e);
            });
        }
      }

      // Subnav updates using js only.
      if (isDesktop) {
        $gnavMainSectionWrapper.attr('aria-expanded', 'true');
      }
      // Clone and displays Secondary Links in respective position according accordion.
      if (!isDesktop) {
        $gnavMainSectionTriggerLink
          .find($gnavMainSectionTrigger)
          .append(
            $('.gnav-section-formatter__mobile-section-toggle').first().clone()
          );
      }

      if (hideHeaderOnScroll) {
        $(window)
          .off('scroll.gnavHeaderBlock')
          .on('scroll.gnavHeaderBlock', _.throttle(updateNavStatus, 300));
        updateNavStatus();
      }

      gnavHeaderTrigger();

      Unison.on('change', function () {
        bp = Unison.fetch.now();
        offersHeight = $gnavOffers.outerHeight(true);
        isMediaLandscape = window.matchMedia('(orientation: landscape)').matches ? true : false;
        isDesktop = parseInt(bp.width, 10) >= parseInt(bps.landscape, 10);
        closeGnav();
        gnavHeaderTrigger();
        widthSpecificClass();
      });

      $triggerResetLabel.on('click.siteHeader', function () {
        if (isDesktop) {
          closeGnav();
        }
      });

      // Mobile icon, navigate back to main gnav sections and displays/collapses all open sections.
      $gnavMobileSectionsMenu.once().on('click', function () {
        closeGnav(true);
      });

      $staticLinks.off('mouseover mouseout').on('mouseover mouseout', function (e) {
        var $self = $(this);
        var $parent = $self.parents('.js-gnav-section-group-v1');
        var $content = $self.closest('.js-header-nav-section__section-content');
        var outLink = e.type === 'mouseout';

        $gnavSectionGroup.not($parent).removeClass('active-section-group');

        if (
          outLink &&
          $(event.relatedTarget).hasClass('js-gnav-section-formatter__link--trigger')
        ) {
          return;
        }
        $linksTriggerReset.prop('checked', true);
        $allGnavLinks.attr('aria-expanded', 'false');
        $gnavLinkToutContent.attr('aria-hidden', 'true');
        $subSectionTriggerReset.prop('checked', true);
        $content.removeClass('gnav-second-panel');
        $parent.toggleClass('active-section-group', !outLink);
      });

      $bottomLinks.off('mouseover').on('mouseover', function () {
        $gnavMainSectionContent.removeClass('gnav-second-panel');
        $gnavSectionGroup.removeClass('active-section-group');
        $linksTriggerReset.add($subSectionTriggerReset).prop('checked', true);
        $allGnavLinks.attr('aria-expanded', 'false');
        $gnavLinkToutContent.attr('aria-hidden', 'true');
      });

      if ($emailSignupLinks.length > 0) {
        emailAnchoredLink =
          $emailSignupLinks.attr('href').substr(0, 2) === '/#' ||
          $emailSignupLinks.attr('href').substr(0) === '#';

        if (emailAnchoredLink) {
          $emailSignupLinks.once().on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
              scrollTop:
                $(document).height() -
                $('.sitewide-footer-formatter').height() +
                $('.js-newsletter-section').position().top
            });
          });
        }
      }

      $allSectionGroupsTrigger.once().on('click', function () {
        toggleSectionGroup(this);
      });

      $gnavHamburger.once().on('click', function (e) {
        var $self = $(this);

        e.preventDefault();
        e.stopPropagation();
        if (isDesktop) {
          return;
        }
        if (!$self.hasClass('site-header-formatter--close-icon')) {
          $gnavHamburgerInput.prop('checked', true);
          $html.toggleClass('active-gnav', true);
        } else {
          $gnavHamburgerInput.prop('checked', false);
          closeGnav();
        }
      });

      $mainSectionTriggerReset.once().on('click', function () {
        if (isDesktop) {
          closeGnav();
        }
      });

      if (!isDesktop) {
        $allSectionTriggerResetLabels
          .off('mouseover.siteHeader touchstart.siteHeader')
          .on('touchstart.siteHeader', function (e) {
            var $self = $(this);
            var $input = $self.prev();

            if (isDesktop && $input.length > 0) {
              if (e.type === 'touchstart') {
                e.preventDefault();
                e.stopPropagation();
              }
              $input.prop('checked', true);
              toggleSectionGroup($input);
            }
          });
      }

      $(document).on('hide_header_offer_banner', function () {
        $template.toggleClass('header-offers-banner-hidden', true);
      });

      $(document).on('check_reset_gnav_radio_buttom', function () {
        closeGnav();
        $mainSectionTriggerReset.prop('checked', true);
      });

      $gnavPCSearch.once().on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $gnavPCSearchSection.addClass('visible');

        $(document).on('click', function (clickEvent) {
          if (!$(clickEvent.target).closest($gnavPCSearchContent).length) {
            $gnavPCSearchSection.removeClass('visible');
            $(document).off('click');
          }
        });
      });

      $gnavSearchSection.once().on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $gnavMainSectionWrapper.addClass('search-visible');
        $gnavMainSection.attr('aria-expanded', 'false');
        $gnavMainSectionContent.attr('aria-hidden', 'true');

        $gnavMobSearchClose.on('click', function () {
          $gnavMainSectionWrapper.removeClass('search-visible');
        });
      });

      $mobMenuLinksLabel.once().on('click', function () {
        $gnavMobSearchClose.trigger('click');
      });

      $gnavSearchIcon.once().on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!isDesktop) {
          $gnavHamburgerInput.prop('checked', true);
          toggleMobileMenu();
          $gnavSearchSection.trigger('click');
        }
      });

      function focusElement(index) {
        $(tabbableElements, $template).not(noTabbableElements).eq(index, 10).focus();
      }

      function focusTimer(index) {
        timer = setTimeout(function () {
          focusElement(index);
        }, 250);
      }

      $(linksToNavigate, $template)
        .not(noTabbableElements)
        .on('keydown', function (e) {
          var $this = $(this);
          var key = e.key;
          var $tabbableElements;
          var index;
          var target;

          if (
            ['ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp', 'Enter', 'Escape'].indexOf(key) > -1
          ) {
            $tabbableElements = $(tabbableElements, $template).not(noTabbableElements);
            index = $tabbableElements.index($this);
            target = null;

            $html.addClass('ada-enabled');
            switch (key) {
              case 'ArrowLeft':
                target = index === 0 ? -1 : index - 1;
                break;
              case 'ArrowUp':
                target = index === 0 ? -1 : index - 1;
                break;
              case 'ArrowRight':
                target = index === $tabbableElements.length - 1 ? 0 : index + 1;
                break;
              case 'ArrowDown':
                target = index === $tabbableElements.length - 1 ? 0 : index + 1;
                break;
              case 'Enter':
                if (e.target) {
                  if (
                    e.target.localName === 'a' &&
                    $(e.target).attr('aria-haspopup') === 'true'
                  ) {
                    e.preventDefault();
                  }
                  if ($(e.target).parents('.js-header-offers-banner-formatter-v1').length > 0) {
                    return;
                  }
                  $(e.target).click();
                }

                if (timer) {
                  clearTimeout(timer);
                }
                // If click on label icon then focus the previous element.
                if ($this.attr('for') === 'gnav_section_trigger_') {
                  focusTimer(index - 1);
                }
                // If click on close icon then focus the previous element.
                if ($this.attr('for') === 'gnav_section_trigger_reset') {
                  focusTimer(index - 1);
                }
                // If the link/label has pop up then click to open
                if ($this[0].hasAttribute('aria-haspopup')) {
                  // Focus next element after a time in case it takes time to load
                  focusTimer(index + 1);
                }
                break;
              case 'Escape':
                $(document).trigger('check_reset_gnav_radio_buttom');
                if (timer) {
                  clearTimeout(timer);
                }
                focusTimer(index - 1);
                break;
            }

            if (target !== null && target !== undefined) {
              focusElement(target);
            }
          }
        });

      $(document).on(
        'mousemove',
        _.debounce(function () {
          // If mouse movement is detected then remove ada class.
          if ($html.hasClass('ada-enabled')) {
            $html.removeClass('ada-enabled');
          }
        }, 200)
      );
    }
  };

  return behavior;
})(jQuery);
